import { useState } from "react";
import { ReactComponent as PenIcon } from "../../../../assets/svg/icons/penEdit.svg";
import "./styles.css";
import { useEditOnboarding } from "../../../../hooks/useEditOnboarding";

type TableVisualizationRowProps = {
  product: IProducts;
};

export default function TableVisualizationRow({
  product,
}: TableVisualizationRowProps) {
  const {
    setOptionForm,
    setDefaultValue
  } = useEditOnboarding();

  return (
    <tr>
      <td>{product.classification}</td>
      <td>{product.trade_name}</td>
      <td>{product.manufacturer}</td>
      <td className="infoButton">
        <PenIcon
          onClick={() => {
            setOptionForm("create-products")
            setDefaultValue(product)
          }}
        />
      </td>
    </tr>
  );
}
